import { render, staticRenderFns } from "./tomaio-repeater.vue?vue&type=template&id=f0f3ed64&scoped=true&"
import script from "./tomaio-repeater.vue?vue&type=script&lang=js&"
export * from "./tomaio-repeater.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0f3ed64",
  null
  
)

export default component.exports